<template>
    <div class="fixed top-0 px-3.5 w-full h-full bg-transparent-basic-3 flex justify-center items-center z-[80]" v-if="modelValue">
        <div class="bg-white p-6 gap-6 flex rounded-05 flex-col items-center justify-center z-40" 
            :class="modalWidth"
        >
            <div class="flex flex-col gap-2 items-center"> 
                <component v-if="displayIcon && displayIcon.label" :is="displayIcon.label" :weight="displayIcon.weight" :color="displayIcon.color" :width="displayIcon.width" :height="displayIcon.height"/>
                <div v-if="modalTitle" class="text-center font-semibold text-base leading-[22px] whitespace-pre-line"> 
                    {{ modalTitle }}
                </div>
                <div v-if="modalContent" class="text-center font-normal leading-[20px] text-content-basic-2 text-sm">
                    {{ modalContent }}
                </div>
                <!-- <template v-slot:modal-content-extra> -->
                <slot name="modal-content-extra"></slot>
            </div>
            <div class="flex gap-2 w-full">
                <designButton
                    v-if="displayCancel && displayCancel.label" :btnType="displayCancel.type" btnSize="MD" :btnText="displayCancel.label"
                    :btnVariant="displayCancel.variant"
                    class="w-full" @click="$emit(displayCancel.action)">
                    <template v-if="$slots['cancel-front-icon']" v-slot:front-icon>
                        <slot name="cancel-front-icon"></slot>
                    </template>
                </designButton>
                <designButton
                    v-if="displayConfirm && displayConfirm.label" :btnType="displayConfirm.type" btnSize="MD" :btnText="displayConfirm.label"
                    :btnVariant="displayConfirm.variant"
                    class="w-full" @click="$emit(displayConfirm.action)">
                    <template v-if="$slots['confirm-front-icon']" v-slot:front-icon>
                        <slot name="confirm-front-icon"></slot>
                    </template>
                </designButton>
            </div>
        </div>
    </div>
</template>

<script>
import designButton from './design-button.vue';
import warning from './icon/warning.vue';
import info from './icon/info.vue';
import check from './icon/check.vue';

const DIALOG_TYPES = { ALERT: 'ALERT', INFO: 'INFO' }

export default {
    components : {
        designButton, warning, info, check
    },
    props : {
        modelValue : { type : Boolean, default : false },
        // 한줄인데 디자인 파일이 진하다 싶으면 Title, 연하면 content 
        modalContent : { type : String },
        modalTitle : { type : String },
        // 새로운 아이콘을 사용하고 싶다면 Import 하여 사용
        iconConfig : { type : Object, 
                        // label: 'warning', color : 'text-white bg-accent-green-3 rounded-full p-1', weight : 'FILL' width : 24 height :24 
                        default : function(){ return {}} },
        confirmConfig : { type : Object, 
                        // { label : 'OK', type : 'RED', action : 'confirm', variant : 'FILL' }
                        default : function(){ return {} } },
        cancelConfig : { type : Object, 
                        // { label : 'Cancel', type : 'SECONDARY', action : 'cancel' ,variant : 'FILL' }
                        default : function(){ return {}} },
        dialogType : { type : String },
        modalWidth : { type : String, default : ' w-[300px] '},
    },
    emits : [ 
        'update:modelValue',
        'confirm',
        'cancel'
    ],
    computed : {
        displayIcon(){
            const fallback = this.iconConfig;
            if(!this.dialogType){
                return fallback;
            }
            const dialogType = this.dialogType.toUpperCase();
            const preset = this.defaultConfig[dialogType];

            if(!preset){
                return fallback;
            }

            return preset.iconConfig || fallback.iconConfig;
        },
        displayConfirm(){
            const fallback = this.confirmConfig;
            if(!this.dialogType){
                return fallback;
            }
            const dialogType = this.dialogType.toUpperCase();
            const preset = this.defaultConfig[dialogType];

            if(!preset){
                return fallback;
            }

            return preset.confirmConfig || fallback.confirmConfig;
        },
        displayCancel(){
            const fallback = this.cancelConfig;
            if(!this.dialogType){
                return fallback;
            }
            const dialogType = this.dialogType.toUpperCase();
            const preset = this.defaultConfig[dialogType];

            if(!preset){
                return fallback;
            }

            return preset.cancelConfig || fallback.cancelConfig;
        },
    },
    data(){
        return { 
            DIALOG_TYPES : DIALOG_TYPES,
            defaultConfig : {
                [DIALOG_TYPES.INFO] : {
                    iconConfig : {label: 'check', color : 'text-white bg-accent-green-3 rounded-full p-1', weight : 'FILL' , width : 24, height : 24},
                    confirmConfig : {label : 'OK', type : 'PRIMARY', action : 'confirm', variant : 'FILL'},
                    cancelConfig : null
                },
                [DIALOG_TYPES.ALERT ] : {
                    iconConfig : {label: 'warning', color : 'text-red-400', weight : 'FILL', width : 24, height : 24 },
                    confirmConfig : {label : 'OK', type : 'RED', action : 'confirm', variant : 'FILL' },
                    cancelConfig : null
                }
            }
        }
    }
}
</script>
